import React from 'react';
import { Phone } from 'lucide-react';
import { Button } from './ui/button';
import { clinicInfo } from '../data/mockData';
import { useLocation } from 'react-router-dom';

const StickyContactBar = () => {
  const location = useLocation();
  
  if (location.pathname === '/locations') {
    return null;
  }

  const handleCall = () => {
    window.location.href = `tel:${clinicInfo.phone}`;
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden">
      <Button 
        onClick={handleCall}
        className="w-full bg-teal-700 hover:bg-teal-800 text-white font-bold text-lg py-6 rounded-none shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] h-16"
      >
        <Phone className="w-6 h-6 mr-3" />
        Call Now to Book
      </Button>
    </div>
  );
};

export default StickyContactBar;
